var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c0a00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2093.87,1367.22l-28.52,229a76.39,76.39,0,0,1-75.63,67h-370.9v957.46Q1560.1,2626,1500,2626a1324,1324,0,0,1-261.62-26V1663.25H953.09a47.78,47.78,0,0,1-47.55-47.73V1329a47.77,47.77,0,0,1,47.55-47.73h285.28V851.48c0-263.73,212.92-477.51,475.56-477.51h332.84a47.78,47.78,0,0,1,47.56,47.73V708.24A47.78,47.78,0,0,1,2046.77,756H1809c-105,0-190.17,85.51-190.17,191v334.26h399.43C2064.09,1281.25,2099.53,1321.61,2093.87,1367.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.90387336cbbfe6b1430749180ac64086.svg";
export { ForwardRef as ReactComponent };